var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#238ce6;}.b{fill:#eff8ff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 22,
    cy: 22,
    r: 22
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.715 9.715)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.691,20.731a.96.96,0,1,1-.96-.96A.963.963,0,0,1,21.691,20.731Zm-4.031-.96a.96.96,0,1,0,.96.96A.963.963,0,0,0,17.66,19.771Zm6.91-2.3v4.991a2.112,2.112,0,0,1-2.111,2.111H2.111A2.112,2.112,0,0,1,0,22.459V17.468a2.112,2.112,0,0,1,2.111-2.111h4.77L4.175,12.65A1.921,1.921,0,0,1,5.533,9.372H8.062V1.92A1.919,1.919,0,0,1,9.982,0h4.607a1.919,1.919,0,0,1,1.92,1.92V9.372h2.529A1.922,1.922,0,0,1,20.4,12.65l-2.707,2.707h4.77A2.112,2.112,0,0,1,24.57,17.468Zm-12.559.849a.385.385,0,0,0,.542,0l6.752-6.752a.386.386,0,0,0-.274-.657h-4.06V1.92a.385.385,0,0,0-.384-.384H9.982A.385.385,0,0,0,9.6,1.92v8.988H5.533a.386.386,0,0,0-.274.657l6.752,6.752Zm11.023-.849a.578.578,0,0,0-.576-.576H16.153l-2.51,2.51a1.923,1.923,0,0,1-2.716,0l-2.51-2.51H2.111a.578.578,0,0,0-.576.576v4.991a.578.578,0,0,0,.576.576H22.459a.578.578,0,0,0,.576-.576Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExport);
export default __webpack_public_path__ + "static/media/download-export.a5f1adce0a2ae517f1162c04cf488f82.svg";
export { ForwardRef as ReactComponent };